import { render, staticRenderFns } from "./m-article-quote-v2.vue?vue&type=template&id=4adf1ac8&scoped=true"
import script from "./m-article-quote-v2.vue?vue&type=script&lang=js"
export * from "./m-article-quote-v2.vue?vue&type=script&lang=js"
import style0 from "./m-article-quote-v2.vue?vue&type=style&index=0&id=4adf1ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf1ac8",
  null
  
)

export default component.exports